import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "./baseUrl";
import { translation } from "./Translation";
import { SubmitButtonSkeleton } from "./SkeletonLoading";

const DISCOUNT_TYPE_OPTIONS = [
  { value: "discount", label: "ثبت تخفیف" },
  { value: "surcharge", label: "افزایش قیمت" },
];

const DISCOUNT_MODE_OPTIONS = [
  { value: "value", label: "بر اساس مبلغ" },
  { value: "percent", label: "بر اساس درصد" },
];

const OrderInvoiceDiscountForm = ({ factorId, onSuccess, lang = "fa", currency = "" }) => {
  const [discountType, setDiscountType] = useState("discount");
  const [discountMode, setDiscountMode] = useState("value");
  const [discountValue, setDiscountValue] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    const numericValue = Number(String(discountValue).replace(/,/g, "").trim());
    if (!numericValue || numericValue <= 0) {
      toast.error("لطفاً مقدار معتبر وارد کنید", {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    if (discountMode === "percent" && numericValue > 100) {
      toast.error("درصد نمی‌تواند بیشتر از ۱۰۰ باشد", {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    setLoading(true);

    axios
      .post(`${baseUrl}/orders/${factorId}/discount`, {
        discount_type: discountType,
        discount_mode: discountMode,
        discount: numericValue,
      })
      .then(() => {
        toast.success(
          translation.toast_error4?.[lang]
            ? translation.toast_error4[lang]
            : "با موفقیت ثبت شد",
          {
            position: "top-center",
            autoClose: 5000,
          }
        );
        setDiscountValue("");
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "خطا در ثبت تخفیف", {
          position: "top-center",
          autoClose: 5000,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <form className="order-invoice-discount" onSubmit={handleSubmit}>
      <div className="order-invoice-discount-grid">
        <div className="order-invoice-discount-box">
          <select
            value={discountType}
            onChange={(event) => setDiscountType(event.target.value)}
            aria-label="نوع تغییر قیمت"
          >
            {DISCOUNT_TYPE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="order-invoice-discount-box">
          <select
            value={discountMode}
            onChange={(event) => setDiscountMode(event.target.value)}
            aria-label="روش محاسبه"
          >
            {DISCOUNT_MODE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="order-invoice-discount-box">
          <input
            type="number"
            min="0"
            step={discountMode === "percent" ? "0.01" : "1"}
            max={discountMode === "percent" ? "100" : undefined}
            value={discountValue}
            onChange={(event) => setDiscountValue(event.target.value)}
            placeholder={
              discountMode === "percent"
                ? "مقدار درصد"
                : `مبلغ${currency ? ` (${currency})` : ""}`
            }
            aria-label="مقدار تخفیف یا افزایش"
          />
        </div>
      </div>

      <button type="submit" className="order-invoice-discount-submit" disabled={loading}>
        {loading ? (
          <SubmitButtonSkeleton />
        ) : (
          "ثبت"
        )}
      </button>
    </form>
  );
};

export default OrderInvoiceDiscountForm;
